module.exports = __webpack_public_path__ + "img/contact-alt.913bf8cc.svg";